import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import { Link } from 'react-router-dom';
import { useT } from 'client/i18n/hooks/useT';
import {
  appStoreLink,
  playStoreLink,
} from '../../../helpers/serverRenderingUtils';
import OutboundLink from '../OutboundLink';
import { Footer } from '../Footer';
import styles from './styles.sass';

export default function CallJoin({ isIOS, isAndroidChrome, openInAppUrl }) {
  const t = useT();
  return (
    <div className={`${styles.recordOnMobile} isV2LegacyPage`}>
      <h2>
        {t(
          'RecordOnMobile.Title',
          'Record with Anchor',
          'Record with Anchor page title'
        )}
      </h2>
      {isIOS && (
        <p>
          <OutboundLink to={appStoreLink()} newWindow>
            <img
              alt="App Store"
              src="https://d12xoj7p9moygp.cloudfront.net/images/appstore-logo.png"
              srcSet="https://d12xoj7p9moygp.cloudfront.net/images/appstore-logo.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/appstore-logo@2x.png 2x"
              width={180}
              height={53}
            />
          </OutboundLink>
        </p>
      )}
      {isAndroidChrome && (
        <p>
          <OutboundLink to={playStoreLink()} newWindow>
            <img
              alt="Google Play Store"
              src="https://d12xoj7p9moygp.cloudfront.net/images/playstore-logo.png"
              srcSet="https://d12xoj7p9moygp.cloudfront.net/images/playstore-logo.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/playstore-logo@2x.png 2x"
              width={180}
              height={54}
            />
          </OutboundLink>
        </p>
      )}
      {!isIOS && !isAndroidChrome && openInAppCallToAction({ t })}
      {(isIOS || isAndroidChrome) &&
        openInAppCallToAction({ url: openInAppUrl, t })}
      <p className={styles.learnAboutAnchor}>
        <Link to="/">
          <strong>
            {t(
              'RecordOnMobile.LearnMoreLink',
              'Learn more about Anchor &gt;',
              'Learn more link text'
            )}
          </strong>
        </Link>
      </p>
      <Footer />
    </div>
  );
}

function openInAppCallToAction({ url = 'https://anch.co/get_anchor', t }) {
  return (
    <div>
      <p>
        <small className={styles.openInAppText}>
          {t(
            'RecordOnMobile.AlreadyAnchorAppUser',
            'Already have the app?',
            'Use Anchor app user message'
          )}
        </small>
      </p>
      <OutboundLink to={url} className="visible-xs-inline visible-sm-inline">
        <Button className={styles.openInApp}>
          {t(
            'RecordOnMobile.OpenInApp',
            'Open in App',
            'Open in App call to action'
          )}
        </Button>
      </OutboundLink>
    </div>
  );
}
